import React from 'react';

const YesodLogo = () => {
  return (
    <div className="logo-container">
      <img 
        src="https://xvhellooihpelwifxuik.supabase.co/storage/v1/object/public/assets//Yesodsybol%20(1).jpeg" 
        alt="Yesod Logo" 
        className="yesod-logo"
      />
    </div>
  );
};

export default YesodLogo;